<script>
export default {
  name: "GoogleMapLine",
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    _line: null,
  }),

  mounted() {
    // https://stackoverflow.com/questions/16180104/get-a-polyline-from-google-maps-directions-v3
    const { Polyline } = this.google.maps;

    let lineOption = null;
    if (this.data.gDirectionFormat) {
      lineOption = this.updateDirection();
    } else {
      //
      lineOption = this.processSimpleLine();
    }
    this._line = new Polyline({
      map: this.map,
      ...lineOption,
    });
  },

  methods: {
    processSimpleLine() {
      let _l = { ...this.data };
      for (let i = 0; i < this.data["path"].length; i++) {
        _l["path"][i] = new this.google.maps.LatLng(
          this.data["path"][i]["lat"],
          this.data["path"][i]["lng"]
        );
      }
      return _l;
    },

    getCustomLineStyle(plotOption) {
      // let lineColor = ["#FF0000", "#00FF00"];

      let plotlyLineOption = {
        path: null,
        strokeColor: "#000000", //lineColor[i],
        // strokeOpacity: 0.8,
        // strokeWeight: 10,
        strokeOpacity: 0,
        fillOpacity: 0,
      };

      // process line
      if (plotOption["dashLine"]) {
        plotlyLineOption["icons"] = [
          {
            icon: {
              path: "M 0,-1 0,1",
              strokeOpacity: 1,
              scale: 6,
            },
            offset: "0",
            repeat: "30px",
          },
        ];

        plotlyLineOption["strokeColor"] = "#03A6F9"; //"#567DF4";
        plotlyLineOption["zIndex"] = 1;
      } else {
        plotlyLineOption["strokeOpacity"] = 0.7;
        plotlyLineOption["strokeWeight"] = 4;
        plotlyLineOption["strokeColor"] = "#00ACF2";
      }

      return plotlyLineOption;
    },

    updateDirection() {
      if (this.map) {
        // https://stackoverflow.com/questions/47168200/google-maps-display-route-from-json
        // for (let i = 0; i < plotData.length; i++) {
        let bounds = new this.google.maps.LatLngBounds(
          this.data.routes[0].bounds.southwest,
          this.data.routes[0].bounds.northeast
        );
        this.data.routes[0].bounds = bounds;

        if (!_.isNil(this.data["rawOptionData"])) {
          this.data.routes[0].overview_path =
            this.google.maps.geometry.encoding.decodePath(
              this.data.routes[0].overview_polyline.points
            );

          this.data.routes[0].legs = this.data.routes[0].legs.map((leg) => {
            leg.start_location = new this.google.maps.LatLng(
              leg.start_location.lat,
              leg.start_location.lng
            );
            leg.end_location = new this.google.maps.LatLng(
              leg.end_location.lat,
              leg.end_location.lng
            );

            leg.steps = leg.steps.map((step) => {
              step.path = this.google.maps.geometry.encoding.decodePath(
                step.polyline.points
              );
              step.start_location = new this.google.maps.LatLng(
                step.start_location.lat,
                step.start_location.lng
              );
              step.end_location = new this.google.maps.LatLng(
                step.end_location.lat,
                step.end_location.lng
              );
              return step;
            });

            return leg;
          });
        }

        // https://stackoverflow.com/questions/39264760/google-map-direction-render-alternate-route-how-to-select-desired-path
        let _plotlyLineOption = _.clone(this.getCustomLineStyle(this.data));
        _plotlyLineOption["path"] = this.data.routes[0].overview_path;

        return _plotlyLineOption;
        // return new google.maps.Polyline(_plotlyLineOption);
        // plotLine.setMap(this.map);

        // https://jsfiddle.net/agmartinez/xp9x0vfg
        // const directionsRenderer = new google.maps.DirectionsRenderer({
        //   preserveViewport: true,
        //   suppressMarkers: true,
        // });
        // directionsRenderer.setMap(this.map);
        // directionsRenderer.setDirections(responseData[i]);
        //
        // }
      }
    },
  },

  render() {},
  beforeDestroy() {
    this._line.setMap(null);
  },
};
</script>
